import { TitleText as StyledTitleText } from './TitleText.styles';
import * as React from 'react';

export interface TitleTextProps {
  /**
   * Title text contents
   */
  label?: string;
  /**
   * Optional children (can be used in the case that the text contents is not a string).
   */
  children?: React.ReactNode;
  /**
   * How heavy is the title's weight?
   */
  weight?: 'bold' | 'regular' | 'light';
  noMargin?: boolean;
  fontSize?: string;
}

/**
 * The second most prominent text on the screen, used in the screen title.
 */
export const TitleText: React.FC<TitleTextProps> = ({
  weight = 'light',
  noMargin = false,
  label,
  children,
  fontSize,
}: TitleTextProps) => {
  return (
    <StyledTitleText weight={weight} noMargin={noMargin} fontSize={fontSize}>
      {label}
      {children}
    </StyledTitleText>
  );
};

export default TitleText;
